"use client"

import { useState, useEffect } from "react"
import { ShoppingCart } from "lucide-react"
import { Button } from "@/components/ui/button"
import { useCart } from "@/context/cart-context"
import { CartSheet } from "@/components/cart-sheet"

export function CartButton() {
  const [isOpen, setIsOpen] = useState(false)
  const [isMounted, setIsMounted] = useState(false)
  const { cartCount } = useCart()

  // Defer mount state to after hydration to prevent hydration mismatch
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsMounted(true)
  }, [])

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        className="relative"
        onClick={() => setIsOpen(true)}
        title="Shopping Cart"
      >
        <ShoppingCart className="h-5 w-5" />
        <span
          className={`absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-primary text-[10px] font-bold text-primary-foreground transition-opacity ${isMounted && cartCount > 0 ? 'opacity-100' : 'opacity-0'}`}
          aria-hidden={!isMounted || cartCount === 0}
        >
          {isMounted && cartCount > 0 ? cartCount : ''}
        </span>
      </Button>
      <CartSheet isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  )
}